import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import HomeZhiZhi from '../views/HomeZhiZhi.vue'
import FoodView from '../views/FoodView.vue'
import BarView from '../views/BarView.vue'
import TravelView from '../views/TravelView.vue'
import PassWordView from '../views/PasswordView.vue'
import MemoryView from '../views/MemoryView.vue'
import GalleryView from '../views/GalleryView.vue'
import SpecialView from '../views/SpecialView.vue'
import DfqViewVue from '@/views/DfqView.vue'
import GameViewVue from '@/views/GameView.vue'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/home',
    name: 'home',
    component: HomeZhiZhi,
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/',
    name: 'register',
    component: RegisterView,
  },
  {
    path: '/food',
    name: 'food',
    component: FoodView,
  },
  {
    path: '/bar',
    name: 'bar',
    component: BarView,
  },
  {
    path: '/travel',
    name: 'travel',
    component: TravelView,
  },
  {
    path: '/password',
    name: 'password',
    component: PassWordView,
  },
  {
    path: '/memory',
    name: 'memory',
    component: MemoryView,
  },
  {
    path: '/gallery',
    name: '/gallery',
    component: GalleryView,
  },
  {
    path: '/special',
    name: '/special',
    component: SpecialView,
  },
  {
    path: '/dfq',
    name: '/dfq',
    component: DfqViewVue,
  },
  {
    path: '/game/:id',  // 确保有 :id 参数
    name: 'game',       // 确保名称是 'game'
    component: GameViewVue,
    props: true         // 允许将路由参数作为 props 传递
  }

];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token')

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 需要登录的路由
    if (!isAuthenticated) {
      // 未登录，重定向到登录页
      next({ name: 'login' })
    } else {
      // 已登录，允许访问
      next()
    }
  } else {
    // 不需要登录的路由，直接放行
    next()
  }
})
export default router
